@for (step of steps; track step; let i = $index) {
  <span class="step"
    [class.active]="(i + 1) <= current"
  [class.complete]="current >= total" (click)="(i + 1) <= current && onStepClick(i)"></span>
}

<span class="label">
  @if (current < total) {
    STEP {{ current }} OF {{ total }}
  }

  @if (current >= total) {
    <span class="cm-icon cm-icon-check small" aria-hidden="true"></span> READY
  }
</span>
